import { ISelectOption } from '@smartshell/ui-kit';

import { IGetHostsForGameAccountResponse } from 'schemas';

import { THost } from './interfaces';

export const getHostOptions = (
  data?: IGetHostsForGameAccountResponse
): {
  hostGroupOptions: ISelectOption[];
  hostOptions: ISelectOption<number, THost>[];
} => {
  const hostGroupOptions: ISelectOption[] =
    data?.hostGroups.map(
      ({ id, title }): ISelectOption => ({ value: id, title })
    ) || [];

  const hostOptions: ISelectOption<number, THost>[] =
    data?.hosts.map(
      ({ id, alias, group_id }): ISelectOption<number, THost> => ({
        value: id,
        title: alias,
        original: {
          id,
          alias,
          group_id,
        },
      })
    ) || [];

  return {
    hostGroupOptions,
    hostOptions,
  };
};
